
import {
  computed, defineComponent, reactive,
} from 'vue';

export default defineComponent({
  name: 'SelecionarTipoRelatorioVendas',
  components: {
  },
  props: {
    valor: {
      type: Number,
      default: 1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    radioButton: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:valor', 'change'],
  setup(props, { emit }) {
    const state = reactive({
      dica: '',
    });

    const computedValor = computed({
      get: () => props.valor,
      set: (valor: number) => {
        emit('update:valor', valor);
      },
    });

    function defineValorSelecionado(valor:number) {
      emit('update:valor', valor);
      emit('change', valor);
    }

    function defineValorMarcado(valor:number) {
      emit('change', valor);
    }

    return {
      props,
      state,
      computedValor,
      defineValorSelecionado,
      defineValorMarcado,
    };
  },
});
